import { RootState } from '../../main/store/main.store.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

export const selectCurrentTaskType = createMemoizedSelector(
  (state: RootState) => state.lesson.currentTask,
  (task) => task?.taskType
);
